import React from "react";

interface ErrorMessageProps {
    errorMessage: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({errorMessage}) => {
    return (
        <div className="mt-2 mb-14 text-red-700 p-1.5 pt-1.5 pb-0.5 rounded-md mx-auto text-center">
            {errorMessage}
        </div>
    )
}

export default ErrorMessage;
